var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85355 12.8536C6.65829 13.0488 6.34171 13.0488 6.14645 12.8536L0.146447 6.85355C-0.0488157 6.65829 -0.0488157 6.34171 0.146447 6.14645L6.14645 0.146446C6.34171 -0.0488157 6.65829 -0.0488157 6.85355 0.146446C7.04882 0.341709 7.04882 0.658291 6.85355 0.853554L1.20711 6.5L6.85355 12.1464C7.04882 12.3417 7.04882 12.6583 6.85355 12.8536Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron-left.73413321.svg";
export { ForwardRef as ReactComponent };